import React from 'react';
import { Card } from 'antd';
import Draggable from 'react-draggable';
import { connect } from 'react-redux';
import { removeLink, removeNode } from '../../actions/graph-modals';
import { Dispatch, func, LinkWithNodes, Node, store } from '../../utils/types';
import { CloseOutlined } from '@ant-design/icons';
import { cropNode, nodesInfoSorter } from '../../utils/helpers';
import { getLinkComponent } from '../../utils/table-columns';
import { useHistory } from 'react-router-dom';
import {
  patchCurrentQueryDetiails,
  queryWithCurrentQueryDetails,
} from '../../actions/query';
import ShowMore from 'react-show-more-text';

type Props = {
  nodes: Node[];
  links: LinkWithNodes[];
  removeNodeAction: func;
  removeLinkAction: func;
  search: string[];
  patchCurrentQueryDetailsAction: func;
  queryWithCurrentQueryDetailsAction: func;
};
const GraphInformationModal = ({
  nodes,
  links,
  removeNodeAction,
  removeLinkAction,
  search,
  patchCurrentQueryDetailsAction,
  queryWithCurrentQueryDetailsAction,
}: Props) => {
  const history = useHistory();

  const handleAdd = (node: Node) => {
    patchCurrentQueryDetailsAction({
      search: [...search, node.symbol],
    });
    queryWithCurrentQueryDetailsAction(history);
  };

  const handleRemove = (node: Node) => {
    patchCurrentQueryDetailsAction({
      search: search.filter((symbol: string) => symbol !== node.symbol),
    });
    queryWithCurrentQueryDetailsAction(history);
  };
  return (
    <>
      {nodes.map((node) => (
        <Draggable
          key={node.id}
          defaultPosition={{
            x: 40 + nodes.length * 10,
            y: 40 + nodes.length * 10,
          }}
          position={undefined}
          bounds="parent"
          handle=".handle"
          scale={1}
        >
          <Card
            title={node.symbol}
            extra={
              <>
                <span
                  className="cursor-pointer text-lg"
                  onClick={() => removeNodeAction(node.id)}
                >
                  <CloseOutlined />
                </span>
              </>
            }
            className="graph-node-modal handle cursor-move max-h-full relative"
          >
            <div className="flex-1 space-y-4 overflow-y-auto">
              <div>
                <span className="font-bold mr-2">{`Link:`}</span>
                {getLinkComponent(node)}
              </div>
              {Object.keys(cropNode(node))
                .sort(nodesInfoSorter)
                .map((field) => (
                  <div key={field} className="flex flex-row">
                    <span className="font-bold mr-2">{`${field}:`}</span>
                    <ShowMore
                      lines={1}
                      more="(Show more)"
                      less="(Show less)"
                      anchorClass=""
                      className="flex-1 max-h-48 overflow-y-auto"
                    >
                      {
                        // @ts-ignore
                        node[field]
                      }
                    </ShowMore>
                  </div>
                ))}
            </div>
            <div className="justify-end">
              {search.some((symbol: string) => symbol === node.symbol) ? (
                <button
                  className="px-3 py-1 text-base font-medium button-search unselectable"
                  onClick={() => handleRemove(node)}
                >
                  Remove
                </button>
              ) : (
                <button
                  className="px-3 py-1 text-base font-medium button-search unselectable"
                  onClick={() => handleAdd(node)}
                >
                  Add
                </button>
              )}
            </div>
          </Card>
        </Draggable>
      ))}

      {links.map((link) => (
        <Draggable
          key={link.source.id + '' + link.target.id}
          defaultPosition={{
            x: 80 + links.length * 10,
            y: 80 + links.length * 10,
          }}
          position={undefined}
          bounds="parent"
          handle=".handle"
          scale={1}
        >
          <Card
            title={link.source.symbol + ' <-> ' + link.target.symbol}
            extra={
              <>
                <span
                  className="cursor-pointer text-lg"
                  onClick={() =>
                    removeLinkAction(link.source.id, link.target.id)
                  }
                >
                  <CloseOutlined />
                </span>
              </>
            }
            className="graph-node-modal handle cursor-move"
          >
            <p>Corr: {link.correlation.toFixed(3)}</p>
            <p>P-Value: {Number.parseFloat(link.pvalue.toPrecision(3)).toExponential(2)}</p>
            <p>Adjusted P-Value: {Number.parseFloat(link.padj.toPrecision(3)).toExponential(2)}</p>
          </Card>
        </Draggable>
      ))}
    </>
  );
};
const mapStateToProps = (state: store) => ({
  nodes: state.graphModals.nodes,
  links: state.graphModals.links,
  search: state.query.currentQueryDetails.search,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  removeNodeAction: (nodeId: number | string) => dispatch(removeNode(nodeId)),
  removeLinkAction: (source: number | string, target: number | string) =>
    dispatch(removeLink(source, target)),
  patchCurrentQueryDetailsAction: (updatedFields: any) =>
    dispatch(patchCurrentQueryDetiails(updatedFields)),
  queryWithCurrentQueryDetailsAction: (history: any) =>
    dispatch(queryWithCurrentQueryDetails(history)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GraphInformationModal);
